import type { NotaBkoResultado } from '@/hooks/useNotaBkoMes';

export function CoberturaAtendimento({ nota }: { nota: NotaBkoResultado }) {
  const c = nota.cobertura_atendimento;
  if (!c) return null;
  return (
    <div className="mx-4 my-3 rounded-md border border-border p-3 text-xs">
      <p className="font-semibold">Trabalho registrado e cobertura da avaliação</p>
      <dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 sm:grid-cols-3">
        {[
          ['Conversas com mensagens suas', c.conversas_com_acao],
          ['Mensagens públicas enviadas', c.mensagens_publicas],
          ['Conversas com avaliação', c.conversas_avaliadas],
          ['Concluídas sem avaliação', c.concluidas_sem_avaliacao],
          ['Conversas com caso aberto', c.conversas_em_aberto],
          ['Conversas sem caso de atendimento', c.conversas_sem_caso],
          ['Somente caso de período anterior', c.conversas_com_caso_anterior ?? 0],
        ].map(([label, value]) => <div key={label}><dt className="text-muted-foreground">{label}</dt><dd className="font-semibold tabular-nums">{value}</dd></div>)}
      </dl>
      <p className="mt-2 text-muted-foreground">O volume inclui contatos comerciais. A nota usa apenas os atendimentos elegíveis avaliados. Fechamentos anteriores ao trabalho do mês não contam como avaliação pendente deste mês. Conversas concluídas sem avaliação precisam ter o processamento corrigido; casos abertos precisam de acompanhamento e conclusão.</p>
    </div>
  );
}
